import React, { useEffect } from "react";
import HeaderOpenData from "./HeaderOpenData";
import FooterOpenData from "./FooterOpenData";
import SearchOpenData from "./beranda/SearchOpenData";
import AboutOpenData from "./beranda/AboutOpenData";
import StatistikPortalCompOpenData from "../../components/open_data/StatistikPortalCompOpenData";
import { MockStatsService } from "../../services/MockStatsService";

const PagesBerandaOpenData = () => {
    useEffect(() => {
        MockStatsService.logVisitor();
    }, []);

    return (
        <div>
            <HeaderOpenData />
            <SearchOpenData />
            <StatistikPortalCompOpenData />
            <AboutOpenData />
            <FooterOpenData />
        </div>
    )
}

export default PagesBerandaOpenData;